const OrderSummary = ({ plan, cycle }) => {
  const monthlyPrice = plan.price[cycle];

  const total =
    cycle === "yearly" ? monthlyPrice * 12 : monthlyPrice;

  return (
    <div className="border rounded-lg p-4 mb-6">
      {/* Plan row */}
      <div className="flex justify-between">
        <div>
          <p className="font-medium">{plan.name}</p>

          {cycle === "yearly" ? (
            <p className="text-sm text-gray-500">
              ₹{monthlyPrice}/month · billed yearly
            </p>
          ) : (
            <p className="text-sm text-gray-500">
              ₹{monthlyPrice}/month
            </p>
          )}
        </div>

        <span className="font-medium">
          ₹{monthlyPrice}/mo
        </span>
      </div>

      {/* Divider */}
      <div className="my-3 border-t" />

      {/* Total */}
      <div className="flex justify-between font-semibold">
        <span>Total</span>
        <span>₹{total}</span>
      </div>
    </div>
  );
};

export default OrderSummary;


// const OrderSummary = ({ plan, cycle }) => {
//     const monthlyPrice = plan.price[cycle];
//     const total =
//       cycle === "yearly" ? monthlyPrice * 12 : monthlyPrice;
  
//     return (
//       <div className="border rounded-lg p-4 mb-6">
//         <div className="flex justify-between">
//           <span>{plan.name}</span>
//           <span>${monthlyPrice}/{cycle}</span>
//         </div>
  
//         <div className="flex justify-between mt-2 font-semibold">
//           <span>Total</span>
//           <span>${total}</span>
//         </div>
//       </div>
//     );
//   };
  
//   export default OrderSummary;
  